"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _STEP_TYPES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var STEP_TYPE_IDS = exports.STEP_TYPE_IDS = {
  JOURNEY: "journey",
  ANNOUNCEMENT: "announcement",
  SATISFACTION: "satisfaction-survey",
  MODAL: "modal",
  HOTSPOT_GROUP: "hotspot-group",
  TOOLTIP_GROUP: "tooltip-group",
  SLIDEOUT: "shorty",
  REDIRECT: "redirect",
  COACHMARK_GROUP: "coachmark-group",
  CHECKLIST: "checklist",
  WAIT_FOR_PAGE: "wait-for-page",
  UNKNOWN: "unknown"
};

var MOBILE_STEP_TYPE_IDS = exports.MOBILE_STEP_TYPE_IDS = {
  FLOW: "mobile-flow",
  MODAL: "mobile-modal",
  TOOLTIP: "mobile-tooltip"
};

var STEP_CATEGORY_IDS = exports.STEP_CATEGORY_IDS = {
  ACTION: "action",
  CONTENT: "content"
};

var MODAL_PATTERNS = exports.MODAL_PATTERNS = {
  MODAL: "modal",
  LEFT: "left",
  FULLSCREEN: "fullscreen",
  SLIDEOUT: "shorty"
};

var SLIDEOUT_POSITIONS = exports.SLIDEOUT_POSITIONS = {
  TOP_LEFT: "topLeft",
  TOP: "top",
  TOP_RIGHT: "topRight",
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
  BOTTOM_LEFT: "bottomLeft",
  BOTTOM: "bottom",
  BOTTOM_RIGHT: "bottomRight"
};

var BEACON_STYLES = exports.BEACON_STYLES = {
  HIDDEN: "hidden"
};

var FIREBASE_TYPES = exports.FIREBASE_TYPES = {
  journeys: "journey",
  experiences: "experience",
  announcements: "announcement",
  satisfaction: "satisfaction-surveys",
  flows: "flow",
  "hotspot-groups": "hotspot-group",
  "coachmark-groups": "coachmark-group",
  actions: "redirect",
  checklists: "checklist",
  "mobile-flows": "mobile-flow"
};

var STEP_TYPES = exports.STEP_TYPES = (_STEP_TYPES = {}, _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.JOURNEY, {
  id: STEP_TYPE_IDS.JOURNEY,
  label: "Journey",
  childNoun: "Journey",
  childrenKey: "steps",
  firebaseKey: "journeys",
  firebaseType: FIREBASE_TYPES["journeys"],
  category: STEP_CATEGORY_IDS.CONTENT,
  contentType: "journeys",
  defaults: {},
  reducer: "steps"
}), _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.ANNOUNCEMENT, {
  id: STEP_TYPE_IDS.ANNOUNCEMENT,
  label: "Announcement",
  childNoun: "Announcement",
  childrenKey: "content",
  firebaseKey: "announcements",
  firebaseType: FIREBASE_TYPES["announcements"],
  category: STEP_CATEGORY_IDS.CONTENT,
  contentType: "announcements",
  defaults: {},
  reducer: "announcements"
}), _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.SATISFACTION, {
  id: STEP_TYPE_IDS.SATISFACTION,
  label: "Satisfaction Survey",
  childNoun: "Satisfaction Survey",
  childrenKey: "content",
  firebaseKey: "satisfaction-surveys",
  firebaseType: FIREBASE_TYPES["satisfaction"],
  category: STEP_CATEGORY_IDS.CONTENT,
  contentType: "satisfaction-surveys",
  defaults: {},
  reducer: "satisfaction"
}), _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.CHECKLIST, {
  id: STEP_TYPE_IDS.CHECKLIST,
  label: "Checklist",
  childNoun: "Checklist Item",
  childrenKey: "items",
  firebaseKey: "checklists",
  firebaseType: FIREBASE_TYPES["checklists"],
  category: STEP_CATEGORY_IDS.CONTENT,
  contentType: "checklists",
  defaults: {},
  reducer: "checklists"
}), _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.MODAL, {
  id: STEP_TYPE_IDS.MODAL,
  label: "Modal",
  statsLabel: "Modals",
  statsChildLabel: "Modal",
  childNoun: "Step",
  childrenKey: "steps",
  firebaseKey: "flows",
  firebaseType: FIREBASE_TYPES["flows"],
  category: STEP_CATEGORY_IDS.CONTENT,
  contentType: "flows",
  defaults: {
    patternType: MODAL_PATTERNS.MODAL,
    sandbox: true, // Ideally this can go away some day.
    skippable: true,
    backdrop: true
  },
  reducer: "steps"
}), _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.TOOLTIP_GROUP, {
  id: STEP_TYPE_IDS.TOOLTIP_GROUP,
  label: "Tooltip Tour",
  statsLabel: "Tooltips",
  statsChildLabel: "Tooltip",
  childNoun: "Tooltip",
  childrenKey: "hotspots",
  firebaseKey: "hotspot-groups",
  firebaseType: FIREBASE_TYPES["hotspot-groups"],
  category: STEP_CATEGORY_IDS.CONTENT,
  contentType: "tooltips",
  defaults: {
    skippable: true,
    sequential: true,
    beaconStyle: BEACON_STYLES.HIDDEN
  },
  reducer: "steps"
}), _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.HOTSPOT_GROUP, {
  id: STEP_TYPE_IDS.HOTSPOT_GROUP,
  label: "Hotspots",
  statsLabel: "Hotspots",
  statsChildLabel: "Hotspot",
  childNoun: "Hotspot",
  childrenKey: "hotspots",
  firebaseKey: "hotspot-groups",
  firebaseType: FIREBASE_TYPES["hotspot-groups"],
  category: STEP_CATEGORY_IDS.CONTENT,
  contentType: "hotspots",
  defaults: {
    skippable: true,
    sequential: false
  },
  reducer: "steps"
}), _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.SLIDEOUT, {
  id: STEP_TYPE_IDS.SLIDEOUT,
  label: "Slideout",
  statsLabel: "Slideouts",
  statsChildLabel: "Slideout",
  childNoun: "Step",
  childrenKey: "steps",
  firebaseKey: "flows",
  firebaseType: FIREBASE_TYPES["flows"],
  category: STEP_CATEGORY_IDS.CONTENT,
  contentType: "flows",
  defaults: {
    patternType: MODAL_PATTERNS.SLIDEOUT,
    sandbox: true,
    skippable: true,
    backdrop: false,
    position: SLIDEOUT_POSITIONS.BOTTOM_LEFT
  },
  reducer: "steps"
}), _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.COACHMARK_GROUP, {
  id: STEP_TYPE_IDS.COACHMARK_GROUP,
  label: "Coachmarks",
  childNoun: "Coachmark",
  childrenKey: "hotspots",
  firebaseKey: "coachmark-groups",
  firebaseType: FIREBASE_TYPES["coachmark-groups"],
  category: STEP_CATEGORY_IDS.CONTENT,
  contentType: "coachmarks"
}), _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.REDIRECT, {
  id: STEP_TYPE_IDS.REDIRECT,
  iconClass: "fa-share",
  label: "Redirect Page",
  childNoun: "Redirect",
  firebaseKey: "actions",
  firebaseType: FIREBASE_TYPES["actions"],
  category: STEP_CATEGORY_IDS.ACTION,
  defaults: {
    newTab: false
  },
  reducer: "steps"
}), _defineProperty(_STEP_TYPES, MOBILE_STEP_TYPE_IDS.FLOW, {
  id: MOBILE_STEP_TYPE_IDS.FLOW,
  label: "Mobile Flow",
  contentType: "mobile-flow"
}), _defineProperty(_STEP_TYPES, MOBILE_STEP_TYPE_IDS.MODAL, {
  id: MOBILE_STEP_TYPE_IDS.MODAL,
  label: "Modal",
  firebaseKey: "mobile-flow-steps",
  contentType: "mobile-flow-steps"
}), _defineProperty(_STEP_TYPES, MOBILE_STEP_TYPE_IDS.TOOLTIP, {
  id: MOBILE_STEP_TYPE_IDS.TOOLTIP,
  label: "Tooltip",
  firebaseKey: "mobile-flow-steps",
  contentType: "mobile-flow-steps"
}), _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.WAIT_FOR_PAGE, {
  id: STEP_TYPE_IDS.WAIT_FOR_PAGE,
  iconClass: "fa-share",
  label: "Wait For Page",
  childNoun: "Wait For Page",
  firebaseKey: "actions",
  firebaseType: FIREBASE_TYPES["actions"],
  category: STEP_CATEGORY_IDS.ACTION,
  defaults: {
    newTab: false
  },
  reducer: "steps"
}), _defineProperty(_STEP_TYPES, STEP_TYPE_IDS.UNKNOWN, {
  id: STEP_TYPE_IDS.UNKNOWN,
  label: "Unknown"
}), _STEP_TYPES);

/*
 * Returns the canonical representation of the given content type
 * string; for instance, `translateContentType("flow") === "flows"`.
 *
 * @param contentType {String} Content type, possibly in non-canonical
 *   format.
 * @return {String} Content type in canonical format, or `undefined`.
 */
var CONTENT_TYPES = exports.CONTENT_TYPES = {
  flow: "flows",
  flows: "flows",
  modal: "flows",
  modals: "flows",
  shorty: "flows",

  hotspot: "hotspot-groups",
  hotspots: "hotspot-groups",
  "hotspot-group": "hotspot-groups",
  "hotspot-groups": "hotspot-groups",
  "tooltip-group": "hotspot-groups",
  "tooltip-groups": "hotspot-groups",

  coachmark: "coachmark-groups",
  coachmarks: "coachmark-groups",
  "coachmark-group": "coachmark-groups",
  "coachmark-groups": "coachmark-groups",

  action: "actions",
  actions: "actions",

  announcement: "announcements",
  announcements: "announcements",

  "satisfaction-survey": "satisfaction-surveys",
  "satisfaction-surveys": "satisfaction-surveys",

  "quantitative-question": "satisfaction-surveys",

  journey: "journeys",
  journeys: "journeys",

  experience: "experiences",
  experiences: "experiences",

  template: "templates",
  templates: "templates",

  checklist: "checklists",
  checklists: "checklists",

  checklistItem: "checklist-item",
  "checklist-item": "checklist-item",

  "mobile-flow": "mobile-flows",
  "mobile-flows": "mobile-flows",

  "mobile-flow-step": "mobile-flow-steps",
  "mobile-flow-steps": "mobile-flow-steps",

  // These both map to `mobile-flow-steps` because of the place they live in Firebase
  "mobile-tooltip": "mobile-flow-steps",
  "mobile-tooltips": "mobile-flow-steps",

  "mobile-modal": "mobile-flow-steps",
  "mobile-modals": "mobile-flow-steps"
};

var STEP_CHILD_KEYS = exports.STEP_CHILD_KEYS = {
  journeys: "steps",
  flows: "steps",
  "hotspot-groups": "hotspots",
  "mobile-flows": "steps",
  checklists: "items",
  "satisfaction-surveys": "steps"
};